import { css } from "@emotion/react";
import { useTheme } from "@emotion/react";

// Catalog card look, matching @components/CatalogIndex AdminListCard
// (CatalogIndex.css): 1px #D7D7D7 border, 4px radius, subtle shadow.
const catalogCard = css`
  height: 100%;
  border: 1px solid var(--gray-3-stroke, #d7d7d7);
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
`;

const useStyles = () => {
  const theme = useTheme() as any;

  return {
    summaryRow: css`
      margin-bottom: 16px;
    `,
    summaryCol: css`
      margin-bottom: 16px;
    `,
    summaryCard: css`
      ${catalogCard};
    `,
    statLabel: css`
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: #888;
    `,
    statValue: css`
      font-size: 32px;
      font-weight: 700;
      color: ${theme?.navy || "#1f2d3d"};
    `,
    inputsCard: css`
      ${catalogCard};
    `,
    inputField: css`
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    `,
    chartCard: css`
      ${catalogCard};
    `,
    chartCardHeader: css`
      background: #fff;
      border-bottom: 1px solid #d7d7d7;
      font-family: "OpenSans", "Open Sans", sans-serif;
      font-size: 24px;
      font-weight: bold;
      color: #1c2655;
      padding: 12px 16px;
    `,
    chartContainer: css`
      position: relative;
      height: 360px;
    `,
    emptyState: css`
      text-align: center;
      padding: 48px;
      color: #888;
    `,
    errorState: css`
      text-align: center;
      padding: 48px;
      color: ${theme?.red || "#b00020"};
    `,
  };
};

export default useStyles;
